import { Component } from '@angular/core';

@Component({
  selector: 'junior-players',
  templateUrl: 'junior-players.html'
})

export class JuniorPlayersComponent {
  private roleId: string = "8F457492-4DB6-4A08-84AE-DF49FE593CFC";

  constructor() { }
}